import script from "./AdminFormElementTel.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminFormElementTel.vue?vue&type=script&setup=true&lang=js"

import "./AdminFormElementTel.vue?vue&type=style&index=0&id=4fe36164&lang=scss"

const __exports__ = script;

export default __exports__